import{styled as e}from"../Theme/stitches.config.js";import"../Theme/ThemeProvider.js";const o=e("div",{});export{o as Box};
